import React, { memo } from 'react';
import WysiwygContentItem from '../wysiwyg_editor/PageContentItem';

import AuthorName from './page_content_items/AuthorName';
import CaptionText from './page_content_items/CaptionText';
import Rectangle from '../wysiwyg_editor/page_content_items/Rectangle';
import Image from '../wysiwyg_editor/page_content_items/Image';
import TextBox from '../wysiwyg_editor/page_content_items/TextBox';
import type { TPageContentItem } from '../../types/wysiwyg_editor';
import useContentItemSprings from '@src/hooks/wysiwyg_editor/useContentItemSprings';
import {
  isAttribution,
  isCaption,
  isImage,
  isRectangle,
  isTextBox
} from '@src/utils/wysiwyg_editor/data';

const PageContentItem = memo(function PageContentItem({
  data
}: {
  data: TPageContentItem;
}) {
  const {
    frameDomSpringApi,
    frameDomSpringValues,
    frameViewboxSpringApi,
    frameViewboxSpringValues
  } = useContentItemSprings(data);

  return (
    <WysiwygContentItem
      data={data}
      frameViewboxSpringValues={frameViewboxSpringValues}
    >
      {isRectangle(data) ? (
        <Rectangle data={data} />
      ) : isAttribution(data) ? (
        <AuthorName data={data} />
      ) : isCaption(data) ? (
        <CaptionText data={data} />
      ) : isImage(data) ? (
        <Image
          key={`${data.id}`}
          data={data}
          frameDomSpringValues={frameDomSpringValues}
          frameDomSpringApi={frameDomSpringApi}
          frameViewboxSpringValues={frameViewboxSpringValues}
          frameViewboxSpringApi={frameViewboxSpringApi}
        />
      ) : isTextBox(data) ? (
        <TextBox
          data={data}
          frameDomSpringValues={frameDomSpringValues}
          frameDomSpringApi={frameDomSpringApi}
          frameViewboxSpringValues={frameViewboxSpringValues}
          frameViewboxSpringApi={frameViewboxSpringApi}
        />
      ) : (
        <unknown-item />
      )}
    </WysiwygContentItem>
  );
});

export default PageContentItem;
